import i18n from "lib/i18n";
import $ from "jquery";
import { defer, first, template } from "lodash";
import { View } from "backbone";
import SpinnerView from "views/spinner_view";
import Comment from "models/comment";
import CommentView from "views/comment_view";
import CommentFormView from "views/comment_form_view";
import Minpubsub from "minpubsub";
/* eslint-disable
    camelcase,
    consistent-return,
    constructor-super,
    func-names,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-param-reassign,
    no-return-assign,
    no-shadow,
    no-this-before-super,
    no-undef,
    no-underscore-dangle,
    no-unused-expressions,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let CommentsListView;

export default CommentsListView = (function () {
  CommentsListView = class CommentsListView extends View {
    static initClass() {
      this.prototype.className = "comments-list-view";
      this.prototype.tagName = "ol";

      this.prototype.noCommentsTemplate = template(`\
<li class="information prominent no-comments">
  <strong><%= i18n.t('comment.label.no_comments_yet') %></strong>
  <br />
  <%= i18n.t('comment.label.have_your_say') %>
</li>\
`, { imports: { i18n } });
    }

    initialize(options) {
      super.initialize(options);
      this.addComment = this.addComment.bind(this);
      this.createNewComment = this.createNewComment.bind(this);
      this.renderNoComments = this.renderNoComments.bind(this);
      this.renderAllComments = this.renderAllComments.bind(this);
      this.renderComments = this.renderComments.bind(this);
      this.renderTeaser = this.renderTeaser.bind(this);
      this.recursiveRender = this.recursiveRender.bind(this);
      this._renderCommentsFragment = this._renderCommentsFragment.bind(this);
      this._commentsFragmentReady = this._commentsFragmentReady.bind(this);
      this.contentSubscription = options.contentSubscription;
      this.permissions = options.permissions;
      // bit of a hack
      this.order = "#oldest";

      this.spinner = new SpinnerView({
        tagName: "li",
        centered: true,
      });

      return this.el.appendChild(this.spinner.el);
    }

    addComment(comment) {
      this.model.set("comment_count", this.model.get("comment_count") + 1);
      Minpubsub.publish("comments:count:updated", [this.model.get("comment_count")]);

      const parentId = comment.get("parent_id");

      const commentView = new CommentView({
        model: comment,
        permissions: this.permissions,
      });

      // find a way to do this directly to the comment view?
      const container = this._getContainerFor(parentId);

      return commentView.$el.prependTo(container);
    }

    createNewComment(contentId, parentId) {
      const parentContainer = this._getContainerFor(parentId);

      const newComment = new Comment({
        content_id: contentId,
        parent_id: parentId,
      });

      const commentFormView = new CommentFormView({
        model: newComment,
        contentSubscription: this.contentSubscription,
      });

      return this._addReplyForm(commentFormView, parentContainer);
    }

    renderNoComments() {
      this.$el.html(this.noCommentsTemplate());
      return Minpubsub.subscribe("comment:new", () => this.$el.find(".information.no-comments").remove());
    }

    renderAllComments(callback) {
      if (this.commentsFragmentReady) {
        this._renderCommentsFragment(this.commentsFragment);
        return typeof callback === "function" ? callback() : undefined;
      }
      return Minpubsub.subscribe("comments:fragment:loaded", (fragment) => {
        this._renderCommentsFragment(fragment);
        return typeof callback === "function" ? callback() : undefined;
      });
    }

    renderComments(model, userRecommendedCommentIds, renderAll) {
      this.userRecommendedCommentIds = userRecommendedCommentIds;
      const comments = model.get("comments");
      const comment_count = model.get("comment_count");

      Minpubsub.publish("comments:count:updated", [comment_count]);

      this.commentsFragment = document.createDocumentFragment();
      this.commentsFragmentReady = false;

      if (renderAll) {
        Minpubsub.subscribe("comments:fragment:loaded", this._renderCommentsFragment);
      } else {
        Minpubsub.subscribe("comments:teaser:fragment:loaded", this._renderCommentsFragment);
        Minpubsub.subscribe("comments:fragment:loaded", this._commentsFragmentReady);
        this.renderTeaser(model.get("comments"));
      }

      return this.recursiveRender(model.get("comments"));
    }

    renderTeaser(comments) {
      comments = first(comments, 2);
      const commentsTeaserFragment = document.createDocumentFragment();

      if (comments.length >= 1) {
        let commentView = new CommentView({
          comment: comments[0],
          userRecommendedCommentIds: this.userRecommendedCommentIds,
          permissions: this.permissions,
          renderChildren: false,
        });
        commentView.$el.appendTo(commentsTeaserFragment);

        if (!commentView.renderFirstChildForTeaser() && (comments.length >= 2)) {
          commentView = new CommentView({
            comment: comments[1],
            userRecommendedCommentIds: this.userRecommendedCommentIds,
            permissions: this.permissions,
            renderChildren: false,
          });
          commentView.$el.appendTo(commentsTeaserFragment);
        }
      }

      return Minpubsub.publish("comments:teaser:fragment:loaded", [commentsTeaserFragment]);
    }

    recursiveRender(comments) {
      if (comments.length) {
        const comment = comments.shift();

        const renderNext = () => defer(this.recursiveRender, comments);

        return new CommentView({
          comment,
          userRecommendedCommentIds: this.userRecommendedCommentIds,
          permissions: this.permissions,
          renderChildren: true,
          renderNext,
        }).$el.appendTo(this.commentsFragment);
      }
      return Minpubsub.publish("comments:fragment:loaded", [this.commentsFragment]);
    }

    sortComments(order) {
      if (this.order !== order) {
        this._changeSortOrder();
        return this.order = order;
      }
    }

    _changeSortOrder() {
      return this.$el.animate({ opacity: 0.25 }, 100, () => {
        this.$el.children("li").each(function () {
          return $(this).prependTo($(this).parent());
        });
        return this.$el.css({ opacity: 1 });
      });
    }

    _renderCommentsFragment(fragment) {
      return this.spinner.hide(() => {
        const scrollLocation = $(window).scrollTop();
        this.$el.find(".comment-view").remove();
        this.$el.prepend(fragment);
        $(window).scrollTop(scrollLocation);
        return Minpubsub.publish("comments:fragment:ready");
      });
    }

    _commentsFragmentReady() {
      return this.commentsFragmentReady = true;
    }

    _addReplyForm(commentFormView, parentContainer) {
      const el = parentContainer || this.$el;
      return commentFormView.$el.prependTo(el);
    }

    _getContainerFor(parentId) {
      // TODO: find some way of asking a comment view for it's replies container
      return $(`#comment_${parentId}`).siblings(".comment-replies").get(0) || this.$el;
    }
  };
  CommentsListView.initClass();
  return CommentsListView;
}());
